var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxDataGrid',_vm._b({attrs:{"data-source":_vm.protocols,"columns":_vm.columns,"on-cell-prepared":_vm.onCellPrepared}},'DxDataGrid',_vm.commonProps.dataGrid,false))
}
var staticRenderFns = []

export { render, staticRenderFns }